import script from "./LeftNav.vue?vue&type=script&setup=true&lang=js"
export * from "./LeftNav.vue?vue&type=script&setup=true&lang=js"

import "./LeftNav.vue?vue&type=style&index=0&id=6a8ca508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a8ca508"]])

export default __exports__